export type SessionKV<T> = {
    load: (sessionId: string) => T | null;
    save: (sessionId: string, partial: Partial<T>) => void;
};

const buildKey = (ns: string, sessionId: string): string => `${ns}:${sessionId}`;

export function createJsonSessionStore<T>(namespace: string): SessionKV<T> {
    return {
        load: (sessionId: string) => {
            try {
                const raw = window.sessionStorage.getItem(buildKey(namespace, sessionId));
                return raw ? (JSON.parse(raw) as T) : null;
            } catch {
                return null;
            }
        },
        save: (sessionId: string, partial: Partial<T>) => {
            try {
                const key = buildKey(namespace, sessionId);
                const existingRaw = window.sessionStorage.getItem(key);
                const existing = existingRaw ? (JSON.parse(existingRaw) as T) : ({} as T);
                const next = { ...(existing as any), ...(partial as any) } as T;
                window.sessionStorage.setItem(key, JSON.stringify(next));
            } catch {
                // ignore persistence errors
            }
        }
    };
}


